export const alertTypes = [
  { value: 1, label: 'Sin alertas', type: 'Sin alertas' },
  { value: 2, label: 'Alertas inmediatas', type: 'Inmediatas' },
  { value: 3, label: 'Alertas diarias', type: 'Diarias' }
];

export const initialFilters = {
  alerts: 1,
  operation: 0,
  propertyTypes: [],
  neighborhoods: [],
  ambiences: [],
  bedrooms: [],
  bathrooms: [],
  garages: [],
  price: {
    min: '',
    max: '',
    currency: 'ARS'
  },
  surface: {
    min: '',
    max: '',
    type: 'totalSurface'
  }
};
